import { render, staticRenderFns } from "./SrBrandLogo.vue?vue&type=template&id=a2eb736a"
import script from "./SrBrandLogo.vue?vue&type=script&lang=js"
export * from "./SrBrandLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports